import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class EglenceExportPdfAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "Rapor/GetEglenceBilgisiRapor";
        super(baseUrl);
    }

    geExportPdfListe(sqId: string) {

        //var request = new ExportPdfListeRequest(sqId);
        let enRequest: IEglenceRequest = {
            sqId: sqId,
        };
        return this.post("", enRequest, true);
    }

}
export default new EglenceExportPdfAPI();
class ExportPdfListeRequest {
    public sqId: string;

    constructor(sicilKodu: string) {

        this.sqId = sicilKodu;

    }
}

interface IEglenceRequest {
    sqId: string;
}

export { ExportPdfListeRequest };